<template>
  <vs-row vs-justify="center">
    <vs-col
      type="flex"
      vs-justify="center"
      vs-align="center"
      vs-lg="12"
      vs-xs="12"
    >
      <vs-card id="v-points-step-0">
        <h3 class="card-title d-flex">Wymiana punktów na nagrody</h3>
        <p class="card-subtitle">{{ header }}</p>
        <MonthlyProfitList
          :totalincomes="totalincomes"
          id="v-points-step-1"
        ></MonthlyProfitList>
      </vs-card>
    </vs-col>
    <vs-popup
      class="holamundo"
      title="Wystąpiły następujące błędy"
      background-color-popup="rgb( 255, 111, 107 )"
      background-color="danger"
      style="color:black"
      :active.sync="error_popup"
    >
      <ul class="common-list">
        <li v-for="error in errors" :key="error">
          <b>{{ error }}</b>
        </li>
      </ul>
    </vs-popup>
    <vs-popup
      class="popup-normal"
      title="Wymieniłeś punkty na kupon!"
      :active.sync="success_popup"
    >
      <vs-row>
        <vs-col vs-lg="6" vs-sm="12">
          <vs-card style="font-size: 15px;"
            >Twoje punkty zostały wymienione na następujący kupon:
            <h4>{{ success.voucher }}</h4>
          </vs-card>
        </vs-col>
        <vs-col vs-lg="6" vs-sm="12">
          <vs-card style="font-size: 15px;"
            >Twój kupon możesz wykorzystać podczas:
            <ul style="margin-left: 1rem;">
              <li>
                zakupów telefonicznych
              </li>
              <li>
                zakupów na stronie
                <a
                  :href="success.url ? success.url : 'https://www.tvokazje.pl'"
                  target="_blank"
                  >TVOkazje</a
                >
              </li>
            </ul>
          </vs-card>
        </vs-col>
      </vs-row>
    </vs-popup>
    <vs-popup
      class="popup-normal"
      title="Czy chesz kontynuować?"
      :active.sync="confirm_popup"
      :button-close-hidden="true"
    >
      <vs-row>
        <vs-col class="text-center">
          <p class="h5">
            Czy na pewno chcesz wymienić {{ confirm_data.points }}
            <i class="mdi mdi-coin text-warning"></i> na kupon "{{
              confirm_data.name
            }}"?
          </p>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col vs-xs="6" vs-lg="6" class="text-center">
          <vs-button
            color="success"
            style="min-width: 7em; font-weight: 700;"
            type="filled"
            size="large"
            class="mt-3"
            @click="buy(confirm_data.id)"
            >Tak</vs-button
          >
        </vs-col>
        <vs-col vs-xs="6" vs-lg="6" class="text-center">
          <vs-button
            color="danger"
            style="min-width: 7em; font-weight: 700;"
            type="filled"
            size="large"
            class="mt-3"
            @click="confirm_popup = false"
            >Nie</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
    <vs-col
      type="flex"
      vs-justify="center"
      vs-align="center"
      vs-lg="6"
      vs-xs="12"
    >
      <vs-card>
        <span class="card-title d-flex h1 v-points-step-2"
          >Dostępne: &nbsp;<strong class="text-warning"
            >{{ saldo["available"] }}
            <i class="mdi mdi-coin text-warning"></i></strong
        ></span>
        <hr class="custom-hr" style="margin: 10px -20px;" />
        <div id="v-points-step-3">
          <vs-row v-for="(voucher, index) in cash_vouchers" :key="index">
            <vs-col vs-lg="8" class="mt-3 ">
              <span class="mt-4 h3"
                >Kupon {{ voucher.value }} zł -
                <strong class="text-warning">
                  {{ voucher.points
                  }}<i class="mdi mdi-coin text-warning"></i></strong
              ></span>
            </vs-col>
            <vs-col vs-lg="4" class="text-right">
              <vs-button
                v-if="voucher.amount > 0 && saldo.available >= voucher.points"
                color="primary"
                type="filled"
                size="medium"
                class="mt-3"
                @click="confirm(voucher.name, voucher.points, voucher.id)"
                >Wymień</vs-button
              >
              <vs-button
                v-if="voucher.amount <= 0 || saldo.available < voucher.points"
                color="#6c757d"
                type="filled"
                size="medium"
                class="mt-3"
                >Wymień
              </vs-button>
            </vs-col>
          </vs-row>
        </div>
      </vs-card>
    </vs-col>
    <vs-col
      type="flex"
      vs-justify="center"
      vs-align="center"
      vs-lg="6"
      vs-xs="12"
    >
      <vs-card>
        <span class="card-title d-flex h1 v-points-step-2"
          >Dostępne: &nbsp;<strong class="text-warning"
            >{{ saldo["available"] }}
            <i class="mdi mdi-coin text-warning"></i></strong
        ></span>
        <hr class="custom-hr" style="margin: 10px -20px;" />
        <div id="v-points-step-4">
          <vs-row v-for="(voucher, index) in product_vouchers" :key="index">
            <vs-col vs-lg="8" class="mt-3 ">
              <span class="mt-3 h3"
                ><a
                  class="voucher-link"
                  :href="voucher.url ? voucher.url : 'https://www.tvokazje.pl'"
                  target="_blank"
                  >{{ voucher.name }}</a
                >
                -
                <strong class="text-warning"
                  >{{ voucher.points
                  }}<i class="mdi mdi-coin text-warning"></i></strong
              ></span>
            </vs-col>
            <vs-col vs-lg="4" class="text-right">
              <vs-button
                v-if="voucher.amount > 0 && saldo.available >= voucher.points"
                color="primary"
                type="filled"
                size="medium"
                class="mt-3"
                @click="
                  confirm(voucher.name, voucher.points, voucher.id, voucher.url)
                "
                >Wymień</vs-button
              >
              <vs-button
                v-if="voucher.amount <= 0 || saldo.available < voucher.points"
                color="#6c757d"
                type="filled"
                size="medium"
                class="mt-3"
                >Wymień
              </vs-button>
            </vs-col>
          </vs-row>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>
<script>
import MonthlyProfitList from "../../dashboards/dashboard-components/monthly-profit-list/MonthlyProfitList";
import saldoDataMixin from "../../../mixins/saldoDataMixin";
import tutorialDataMixin from "../../../mixins/tutorialDataMixin";
import buyVoucherDataMixin from "../../../mixins/buyVoucherDataMixin";
import axios from "axios";

export default {
  name: "Points",
  data: () => ({
    saldo: [],
    voucher_amounts: [],
    cash_vouchers: [],
    percentage_vouchers: [],
    product_vouchers: [],
    errors: [],
    success: {},
    error_popup: false,
    success_popup: false,
    confirm_popup: false,
    confirm_data: []
  }),
  props: {
    header: {
      type: String,
      required: true
    },
    refreshUserData: {
      type: Function,
      default: null
    }
  },
  mixins: [saldoDataMixin, tutorialDataMixin, buyVoucherDataMixin],
  components: {
    MonthlyProfitList
  },
  methods: {
    confirm(name, points, id, url, image_url = null) {
      this.confirm_data = {
        name: name,
        points: points,
        id: id,
        url: url,
        image_url: image_url
      };
      this.confirm_popup = true;
    },
    buy(id) {
      this.confirm_popup = false;
      this.errors = [];
      this.success = [];
      let data = {
        voucher_id: id
      };
      axios
        .post(
          process.env.VUE_APP_LARAVEL_ENDPOINT + "/api/user/buy-voucher",
          data
        )
        .then(response => {
          this.success = {
            voucher: response.data.transaction.voucher.name,
            exp: response.data.transaction.voucher.expired_at,
            url: response.data.transaction.voucher.url
          };
          this.success_popup = true;
          this.refreshData();
        })
        .catch(error => {
          this.errors = [];
          if (error.response) {
            let code = error.response.data.code;
            if (code === "invalid_voucher")
              this.errors.push(
                "Taki bon nie istnieje, spróbuj ponownie później."
              );
            else if (code === "insufficient_funds")
              this.errors.push("Brak wystarczającej ilości środków.");
            else
              this.errors.push(
                "Wystąpił nieznany błąd, spróbuj ponownie później."
              );
          } else
            this.errors.push(
              "Wystąpił nieznany błąd, spróbuj ponownie później."
            );
          this.error_popup = true;
        });
    },
    refreshData() {
      this.getUserSaldo();
      this.getVouchersSums();
      this.getVouchers();
      if (this.$route.name === "Panel klubowicza") {
        this.refreshUserData();
      }
    }
  },
  created() {
    this.getUserSaldo();
    this.getVouchersSums();
    this.getVouchers();
  },
  computed: {
    totalincomes: function() {
      let products = [];
      let colors = [
        "text-danger",
        "text-warning",
        "text-primary",
        "text-success",
        "text-black"
      ];
      for (let index = 0; index < this.voucher_amounts.count; index++) {
        const element = this.voucher_amounts.product[index];
        products.push({
          gridlg: "vs-lg-3",
          gridsm: "vs-sm-6",
          iconcolor: colors[index % 6],
          icon: "mdi mdi-shopping",
          textcolor: "text-dark",
          text: "Aktywne kupony " + element["name"],
          money: element["value"],
          tooltip:
            'To suma Twoich wszystkich aktywnych KUPONÓW "' +
            element["name"] +
            '". Możesz je wykorzystać w trakcie zakupów telefonicznych lub na stronie TVOkazje.'
        });
      }
      let cash = [
        {
          gridlg: "vs-lg-3",
          gridsm: "vs-sm-6",
          iconcolor: "text-primary",
          icon: "mdi mdi-sale",
          textcolor: "text-dark",
          text: "Aktywne kupony PLN10",
          money: this.voucher_amounts["10"],
          tooltip:
            "To suma Twoich aktywnych KUPONÓW 10zł. Możesz je wykorzystać w trakcie zakupów telefonicznych lub na stronie TVOkazje."
        },
        {
          gridlg: "vs-lg-3",
          gridsm: "vs-sm-6",
          iconcolor: "text-success",
          icon: "mdi mdi-sale",
          textcolor: "text-dark",
          text: "Aktywne kupony PLN20",
          money: this.voucher_amounts["20"],
          tooltip:
            "To suma Twoich aktywnych KUPONÓW 20zł. Możesz je wykorzystać w trakcie zakupów telefonicznych lub na stronie TVOkazje."
        },
        {
          gridlg: "vs-lg-3",
          gridsm: "vs-sm-6",
          iconcolor: "text-black",
          icon: "mdi mdi-sale",
          textcolor: "text-dark",
          text: "Aktywne kupony PLN50",
          money: this.voucher_amounts["50"],
          tooltip:
            "To suma Twoich aktywnych KUPONÓW 50zł. Możesz je wykorzystać w trakcie zakupów telefonicznych lub na stronie TVOkazje."
        },
        {
          gridlg: "vs-lg-3",
          gridsm: "vs-sm-6",
          iconcolor: "text-warning",
          icon: "mdi mdi-sale",
          textcolor: "text-dark",
          text: "Aktywne kupony PLN100",
          money: this.voucher_amounts["100"],
          tooltip:
            "To suma Twoich aktywnych KUPONÓW 100zł. Możesz je wykorzystać w trakcie zakupów telefonicznych lub na stronie TVOkazje."
        }
      ];
      return cash.concat(products);
    }
  }
};
</script>

<style>
.dark-theme .popup-normal .vs-popup {
  background: #343d57 none repeat scroll 0% 0% !important;
}
.voucher-link {
  color: #2b2b2b;
  text-decoration: none;
}
.dark-theme .voucher-link {
  color: rgba(255, 255, 255, 0.7);
}
.dark-theme .voucher-link:hover {
  color: #2962ff;
}
</style>
